import { SxProps, Theme } from '@mui/material';
import { atlasSemantic } from 'src/theme/atlas/tokens';
import styled from 'styled-components';

export const exportGroup: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const exportInfoIcon: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  color: atlasSemantic.color.type.muted,
  cursor: 'default',
};

export const PageContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${atlasSemantic.color.surface.default};
  padding: ${(props) => props.theme.atlas.core.spacing[3]}
    ${(props) => props.theme.atlas.core.spacing[6]};
  gap: ${(props) => props.theme.atlas.core.spacing[4]};
`;

export const PageTitle = styled.h1`
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  color: ${atlasSemantic.color.type.default};
`;

export const PageSubtitle = styled.p`
  margin: 4px 0 0;
  font-size: 14px;
  color: ${atlasSemantic.color.type.muted};
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 71px;
`;
